var styles = {
  "Container": "_Container_1ihq8_35",
  "ImageInfo": "_ImageInfo_1ihq8_41",
  "SpacingBoxWrapper": "_SpacingBoxWrapper_1ihq8_46",
  "SpacingBox": "_SpacingBox_1ihq8_46",
  "SpacingHeading": "_SpacingHeading_1ihq8_64",
  "Section": "_Section_1ihq8_78",
  "Field": "_Field_1ihq8_83",
  "AlignmentList": "_AlignmentList_1ihq8_95",
  "AlignmentTitle": "_AlignmentTitle_1ihq8_101"
};

export { styles as default };
